import { render, staticRenderFns } from "./CarHealthTabReminders.vue?vue&type=template&id=25f52b4e&"
import script from "./CarHealthTabReminders.vue?vue&type=script&lang=ts&"
export * from "./CarHealthTabReminders.vue?vue&type=script&lang=ts&"
import style0 from "./CarHealthTabReminders.vue?vue&type=style&index=0&id=25f52b4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports